window.addEventListener("load", (event) => {
    var slider = document.getElementById("custom-slider");


    if (slider) {
        var images = slider.querySelectorAll("img");


        function changeSlide() {
            slider = document.getElementById("custom-slider");
            images = slider.getElementsByTagName("img");
            var nextBanner;

            for (var i = 0; i < images.length; i++) {

                slider = document.getElementById("custom-slider");
                images = slider.getElementsByTagName("img");

                if (images[i].classList.contains("current-banner")) {
                    images[i].classList.remove("current-banner");
                    if (images[i].nextElementSibling) {
                        nextBanner = images[i].nextElementSibling;
                        images[i].nextElementSibling.classList.add("current-banner");
                        break;
                    } else {
                        nextBanner = images[0];
                        images[0].classList.add("current-banner");
                    }

                }
            }

            if (nextBanner) {
                nextBanner.classList.add("current-banner");
                nextBanner.previousElementSibling.classList.add("last-banner");
                setTimeout(() => {

                    slider.appendChild(nextBanner.previousElementSibling);
                    var lastBanners = document.getElementsByClassName("last-banner");

                    for (var i = 0; i < lastBanners.length; i++) {
                        lastBanners[i].classList.remove("last-banner");
                    }

                }, 2000);


            }

        };
        setTimeout(() => {
            setInterval(changeSlide, 5000);

        }, 1000);
    }
})